"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.updateMenuLabels = updateMenuLabels;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _Apps = _interopRequireDefault(require("@material-ui/icons/Apps"));

var _Collections = _interopRequireDefault(require("@material-ui/icons/Collections"));

var _ListAlt = _interopRequireDefault(require("@material-ui/icons/ListAlt"));

var _Info = _interopRequireDefault(require("@material-ui/icons/Info"));

var _utils = require("../Configurator/utils");

var _Wapp = require("wapplr-react/dist/common/Wapp");

//import Logo from "configurator-studio-arkitekter-components/dist/common/components/Logo";
var style = require("./menuStyle_css.js")["default"];

function UpdatableText(props) {
  var context = (0, _react.useContext)(_Wapp.WappContext);
  var wapp = context.wapp;
  wapp.styles.use(style);

  var _useState = (0, _react.useState)(props.text || ""),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      text = _useState2[0],
      _setText = _useState2[1];

  var _useState3 = (0, _react.useState)(props.span || ""),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      span = _useState4[0],
      _setSpan = _useState4[1];

  (0, _react.useEffect)(function () {
    if (props.text !== text || props.span !== span) {
      _setText(props.text);

      _setSpan(props.span);
    }
  }, [props.text, props.span]);
  (0, _react.useEffect)(function () {
    if (props.effect) {
      props.effect({
        setText: function () {
          var _setText2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(value) {
            return _regenerator["default"].wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    if (!(value !== text)) {
                      _context.next = 3;
                      break;
                    }

                    _context.next = 3;
                    return _setText(value);

                  case 3:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          function setText(_x) {
            return _setText2.apply(this, arguments);
          }

          return setText;
        }(),
        setSpan: function () {
          var _setSpan2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(value) {
            return _regenerator["default"].wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    if (!(value !== span)) {
                      _context2.next = 3;
                      break;
                    }

                    _context2.next = 3;
                    return _setSpan(value);

                  case 3:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          }));

          function setSpan(_x2) {
            return _setSpan2.apply(this, arguments);
          }

          return setSpan;
        }()
      });
    }

    return function () {
      if (props.effect) {
        props.effect(null);
      }
    };
  }, [text, span]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: style.label
  }, text ? /*#__PURE__*/_react["default"].createElement("span", {
    className: style.text
  }, text) : null, span ? /*#__PURE__*/_react["default"].createElement("span", {
    className: style.span
  }, span) : null);
}

function updateMenuLabels(_ref) {
  var _data$models, _model$collections, _data$settings, _data$settings$basic_, _model$steps;

  var configuratorContext = _ref.configuratorContext,
      menuLabels = _ref.menuLabels,
      appContext = _ref.appContext;
  var data = configuratorContext.data,
      configuration = configuratorContext.configuration,
      translate = configuratorContext.translate;
  var menus = appContext.menus;
  var model = configuration !== null && configuration !== void 0 && configuration.selectedModel && (_data$models = data.models) !== null && _data$models !== void 0 && _data$models.length ? data.models.find(function (model) {
    return model.key === configuration.selectedModel;
  }) : null;
  var selectedModel = model ? translate(model.name) : "";
  var collection = configuration !== null && configuration !== void 0 && configuration.selectedCollection && model !== null && model !== void 0 && (_model$collections = model.collections) !== null && _model$collections !== void 0 && _model$collections.length ? model.collections.find(function (collection) {
    return collection.key === configuration.selectedCollection;
  }) : null;
  var selectedCollection = collection ? translate(collection.name) : configuration !== null && configuration !== void 0 && configuration.isCustomCollection ? translate(menus.collectionsMenuCustomSpan) : "";
  var selectedLang = configuration.selectedLang;
  var currency = ((_data$settings = data.settings) === null || _data$settings === void 0 ? void 0 : (_data$settings$basic_ = _data$settings.basic_settings) === null || _data$settings$basic_ === void 0 ? void 0 : _data$settings$basic_.currency[selectedLang]) || "";
  var price = (0, _utils.getPrice)(configuration.price, data, selectedLang) ? (0, _utils.getPrice)(configuration.price, data, selectedLang).toString().replace(/(\d)(?=(\d{3})+$)/g, "$1 ") + " " + currency : "";

  if (menuLabels.models) {
    menuLabels.models.setSpan(selectedModel);
  }

  if (menuLabels.collections) {
    menuLabels.collections.setSpan(selectedCollection);
  }

  if (menuLabels.summary) {
    menuLabels.summary.setSpan(price);
  }

  if ((_model$steps = model.steps) !== null && _model$steps !== void 0 && _model$steps.length) {
    model.steps.forEach(function (step) {
      var _step$options;

      if ((_step$options = step.options) !== null && _step$options !== void 0 && _step$options.length) {
        step.options.forEach(function (question) {
          var span = configuration.steps && configuration.steps[step.key] && configuration.steps[step.key][question.key] && configuration.steps[step.key][question.key].name && translate(configuration.steps[step.key][question.key].name);

          if (menuLabels[step.key + "_" + question.key]) {
            menuLabels[step.key + "_" + question.key].setSpan(span);
          }
        });
      }
    });
  }
}

function getMenu() {
  var _data$models2, _model$collections2, _data$settings2, _data$settings2$basic, _data$models3, _model$steps2;

  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var context = props.context,
      appContext = props.appContext,
      postContext = props.postContext,
      configuratorContext = props.configuratorContext,
      collectMenuLabelsUpdate = props.collectMenuLabelsUpdate,
      showPrice = props.showPrice;
  var menus = appContext.menus,
      routes = appContext.routes;
  var data = configuratorContext.data,
      configuration = configuratorContext.configuration,
      translate = configuratorContext.translate;
  var post = postContext.post;
  var showConfiguration = (post === null || post === void 0 ? void 0 : post._id) && data.models;

  if (!showConfiguration) {
    return null;
  }

  function onClickBefore(_x3) {
    return _onClickBefore.apply(this, arguments);
  }

  function _onClickBefore() {
    _onClickBefore = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(p) {
      var _appContext$template;

      var narrow, open, drawerClose;
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              narrow = p.narrow, open = p.open, drawerClose = p.drawerClose;

              if (!(narrow && open)) {
                _context3.next = 6;
                break;
              }

              _context3.next = 4;
              return drawerClose();

            case 4:
              _context3.next = 6;
              return new Promise(function (resolve) {
                return setTimeout(resolve, 500);
              });

            case 6:
              if (!((_appContext$template = appContext.template) !== null && _appContext$template !== void 0 && _appContext$template.actions)) {
                _context3.next = 9;
                break;
              }

              _context3.next = 9;
              return appContext.template.actions.scrollTop();

            case 9:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return _onClickBefore.apply(this, arguments);
  }

  var model = configuration !== null && configuration !== void 0 && configuration.selectedModel && (_data$models2 = data.models) !== null && _data$models2 !== void 0 && _data$models2.length ? data.models.find(function (model) {
    return model.key === configuration.selectedModel;
  }) : null;
  var selectedModel = model ? translate(model.name) : "";
  var collection = configuration !== null && configuration !== void 0 && configuration.selectedCollection && model !== null && model !== void 0 && (_model$collections2 = model.collections) !== null && _model$collections2 !== void 0 && _model$collections2.length ? model.collections.find(function (collection) {
    return collection.key === configuration.selectedCollection;
  }) : null;
  var selectedCollection = collection ? translate(collection.name) : configuration !== null && configuration !== void 0 && configuration.isCustomCollection ? translate(menus.collectionsMenuCustomSpan) : "";
  var selectedLang = configuration.selectedLang;
  var currency = ((_data$settings2 = data.settings) === null || _data$settings2 === void 0 ? void 0 : (_data$settings2$basic = _data$settings2.basic_settings) === null || _data$settings2$basic === void 0 ? void 0 : _data$settings2$basic.currency[selectedLang]) || "";
  var price = (0, _utils.getPrice)(configuration.price, data, selectedLang) ? (0, _utils.getPrice)(configuration.price, data, selectedLang).toString().replace(/(\d)(?=(\d{3})+$)/g, "$1 ") + " " + currency : "";

  function formatAndCurrency(p) {
    return p ? p.toString().replace(/(\d)(?=(\d{3})+$)/g, "$1 ") + " " + currency : "";
  }

  var hideModels = ((_data$models3 = data.models) === null || _data$models3 === void 0 ? void 0 : _data$models3.length) === 1 && model && data.models[0].key === model.key || !data.models || data.models && data.models.length === 0;
  var hideCollections = !model || model && !model.collections || model && model.collections && model.collections.length === 0 || model && model.collections && model.collections.length === 1;
  return [{
    name: translate(menus.descriptionMenu),
    href: "/",
    Icon: _Info["default"]
    /*function () {
    return (
    <div style={{height:"24px"}}><Logo /></div>
    )
    }*/
    ,
    onClickBefore: onClickBefore,
    className: function className(_ref2) {
      var style = _ref2.style;
      return context.res.wappResponse.route.requestPath === "/" ? style.selectedMenu : null;
    }
  }].concat((0, _toConsumableArray2["default"])(!hideModels ? [{
    name: /*#__PURE__*/_react["default"].createElement(UpdatableText, {
      text: translate(menus.modelsMenu),
      span: showPrice && model !== null && model !== void 0 && model.price ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", null, selectedModel), /*#__PURE__*/_react["default"].createElement("span", null, formatAndCurrency((0, _utils.getPrice)(model.price, data, selectedLang)))) : /*#__PURE__*/_react["default"].createElement("span", null, selectedModel),
      effect: collectMenuLabelsUpdate ? function (current) {
        return collectMenuLabelsUpdate("models", current);
      } : null
    }),
    href: routes.modelsRoute,
    Icon: _Apps["default"],
    onClickBefore: onClickBefore,
    className: function className(_ref3) {
      var style = _ref3.style;
      return context.res.wappResponse.route.requestPath === routes.modelsRoute ? style.selectedMenu : null;
    }
  }] : []), [{
    divider: true
  }], (0, _toConsumableArray2["default"])(model !== null && model !== void 0 && model.key && !hideCollections ? [{
    name: /*#__PURE__*/_react["default"].createElement(UpdatableText, {
      text: translate(menus.collectionsMenu),
      span: selectedCollection,
      effect: collectMenuLabelsUpdate ? function (current) {
        return collectMenuLabelsUpdate("collections", current);
      } : null
    }),
    href: routes.modelsRoute + "/" + model.key + routes.collectionsRoute,
    Icon: _Collections["default"],
    onClickBefore: onClickBefore,
    className: function className(_ref4) {
      var style = _ref4.style;
      return context.res.wappResponse.route.requestPath === routes.modelsRoute + "/" + model.key + routes.collectionsRoute ? style.selectedMenu : null;
    }
  }] : []), (0, _toConsumableArray2["default"])(model !== null && model !== void 0 && (_model$steps2 = model.steps) !== null && _model$steps2 !== void 0 && _model$steps2.length ? [].concat((0, _toConsumableArray2["default"])(model.steps.map(function (step) {
    var _step$options2;

    return {
      name: translate(step.name),
      items: (0, _toConsumableArray2["default"])((_step$options2 = step.options) !== null && _step$options2 !== void 0 && _step$options2.length ? step.options.map(function (question) {
        var spanName = configuration.steps && configuration.steps[step.key] && configuration.steps[step.key][question.key] && configuration.steps[step.key][question.key].name && translate(configuration.steps[step.key][question.key].name);
        var spanPrice = configuration.steps && configuration.steps[step.key] && configuration.steps[step.key][question.key] && configuration.steps[step.key][question.key].price && (0, _utils.getPrice)(configuration.steps[step.key][question.key].price, data, selectedLang);
        return {
          name: /*#__PURE__*/_react["default"].createElement(UpdatableText, {
            text: translate(question.name),
            span: showPrice && spanPrice ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", null, spanName), /*#__PURE__*/_react["default"].createElement("span", null, formatAndCurrency(spanPrice))) : /*#__PURE__*/_react["default"].createElement("span", null, spanName),
            effect: collectMenuLabelsUpdate ? function (current) {
              return collectMenuLabelsUpdate(step.key + "_" + question.key, current);
            } : null
          }),
          href: routes.modelsRoute + "/" + model.key + "/" + step.key + "/" + question.key,
          onClickBefore: onClickBefore,
          className: function className(_ref5) {
            var style = _ref5.style;
            return context.res.wappResponse.route.requestPath === routes.modelsRoute + "/" + model.key + "/" + step.key + "/" + question.key ? style.selectedMenu : null;
          }
        };
      }) : [])
    };
  })), [{
    divider: true
  }]) : []), [{
    name: /*#__PURE__*/_react["default"].createElement(UpdatableText, {
      text: translate(menus.summaryMenu),
      span: price,
      effect: collectMenuLabelsUpdate ? function (current) {
        return collectMenuLabelsUpdate("summary", current);
      } : null
    }),
    href: routes.summaryRoute,
    Icon: _ListAlt["default"],
    onClickBefore: onClickBefore,
    className: function className(_ref6) {
      var style = _ref6.style;
      return context.res.wappResponse.route.requestPath === routes.summaryRoute ? style.selectedMenu : null;
    }
  }]);
}

var _default = getMenu;
exports["default"] = _default;